import { getAnalytics, logEvent } from "firebase/analytics";
import { initializeApp } from "firebase/app";

export function logAnalyticsEvent(eventName: string) {
    // Check if development mode
    const isDevelopment = process.env.NODE_ENV === 'development';
    if (isDevelopment) {
        return;
    }
    const savedPreference = localStorage.getItem('analytics-enabled');
    if (savedPreference === null || savedPreference === 'false') {
        return;
    }
    const analytics = getAnalytics();
    logEvent(analytics, eventName);
}

export function enableAnalytics() {
    // Check if development mode
    const isDevelopment = process.env.NODE_ENV === 'development';

    if (isDevelopment) {
        return;
    }

    const firebaseConfig = {
        apiKey: "AIzaSyCasU2SRAlV_BbQpJzx-Dk4zmTTPZS3VOM",
        authDomain: "inspiriva.firebaseapp.com",
        projectId: "inspiriva",
        storageBucket: "inspiriva.appspot.com",
        messagingSenderId: "849359332002",
        appId: "1:849359332002:web:1fdc95c4fc3d13f8c0edfb",
        measurementId: "G-FDNMSDQ6TQ"
    };
    // Initialize Firebase
    const app = initializeApp(firebaseConfig);

    // Initialize Analytics and get a reference to the service
    const analytics = getAnalytics(app);
    return analytics;
};
export function disableAnalytics() {
    const analytics = getAnalytics();
    analytics.app.automaticDataCollectionEnabled = false;
}